/**
 * MonthBars — бар-чарт по месяцам (recharts) для карточек «Трендов»:
 * серии стеком или рядом, месяц «мар»-формата, тултип с полными числами.
 * Hex — точечная палитра чартов (как Sparkline), не токены темы.
 */

import dayjs from 'dayjs';
import {Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis} from 'recharts';

import {formatNumber} from '@utils/format';

export type MonthBarsSeries = {
  key: string;
  label: string;
  color: string;
  /** Общий stackId у серий → бары стекуются */
  stackId?: string;
};

type Props = {
  data: Record<string, number | string>[];
  series: MonthBarsSeries[];
  height?: number;
};

const fmtMonth = (m: unknown): string =>
  dayjs(`${String(m)}-01`)
    .format('MMM')
    .replace('.', '');

export const MonthBars = ({data, series, height = 168}: Props) => (
  <div style={{height}}>
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} margin={{top: 6, right: 4, left: 4, bottom: 0}} barCategoryGap="28%">
        <CartesianGrid vertical={false} stroke="#EDEFF3" />
        <XAxis
          dataKey="month"
          tickFormatter={fmtMonth}
          tickLine={false}
          axisLine={false}
          tick={{fontSize: 11, fill: '#8A8F99', fontFamily: 'JetBrains Mono, monospace'}}
          dy={4}
        />
        <Tooltip
          cursor={{fill: '#F3F5F9'}}
          formatter={(value: number | string, name: string) => [
            formatNumber(Number(value)),
            series.find((s) => s.key === name)?.label ?? name,
          ]}
          labelFormatter={(m) => dayjs(`${String(m)}-01`).format('MMMM YYYY')}
          contentStyle={{
            borderRadius: 10,
            border: '1px solid #E4E7EC',
            fontSize: 12,
            padding: '8px 11px',
          }}
        />
        {series.map((s) => (
          <Bar
            key={s.key}
            dataKey={s.key}
            stackId={s.stackId}
            fill={s.color}
            radius={s.stackId === undefined ? [5, 5, 0, 0] : undefined}
            maxBarSize={26}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  </div>
);
